import Vue from 'vue';
import VueRouter from 'vue-router';
//import MarkdownEditor from '@voraciousdev/vue-markdown-editor';

require('./bootstrap');

import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import VueGtag from 'vue-gtag';

/**
 * Sentry
 */
Sentry.init({
    Vue,
    environment: process.env.APP_ENV,
    dsn: process.env.MIX_SENTRY_LARAVEL_DSN || '',
    integrations: [new Integrations.BrowserTracing()],
    ignoreErrors: [/^Network Error$/],
});

document.addEventListener('DOMContentLoaded', () => {
    /**
     * HAMMER WEB
     */
    if(document.getElementById("app-web")) {
        document
            .querySelector('#hamburger')
            .addEventListener('click', () => {
                document
                    .querySelector('#menu')
                    .classList.remove('hidden');
            });

        document.querySelector('#cross').addEventListener('click', () => {
            document.querySelector('#menu').classList.add('hidden');
        });

        document.querySelectorAll('[data-tab]').forEach((element) => {
            element.addEventListener('click', function () {
                const target = this.getAttribute('data-tab');
                const targetElement = document.querySelector(
                    `[data-tab-target="${target}"]`,
                );

                document.querySelectorAll('[data-tab]').forEach((single) => {
                    single.classList.remove('underline');
                });

                this.classList.add('underline');

                document
                    .querySelectorAll('[data-tab-target]')
                    .forEach((single) => {
                        single.classList.add('hidden');
                    });
                targetElement.classList.remove('hidden');
            });
        });

        document.querySelectorAll('[data-accordion]').forEach((element) => {
            element.addEventListener('click', function () {
                const target = this.getAttribute('data-accordion');
                const targetElement = document.querySelector(`[data-accordion-target="${target}"]`);

                if (targetElement.classList.contains('hidden')) {
                    this.querySelector('.icon').classList.add('rotate-180');
                    targetElement.classList.remove('hidden');
                    window.location.hash = target;
                } else {
                    targetElement.classList.add('hidden');
                    this.querySelector('.icon').classList.remove(
                        'rotate-180',
                    );
                    window.location.hash = '_';
                }
            });
        });

        const faqs = document.querySelectorAll('[data-accordion]');
        const { hash } = window.location;
        if (faqs && faqs.length && hash) {
            const editedHash = hash.replace('#', '');
            const splited = editedHash.split('_');
            document.querySelector(`[data-tab="${splited[0]}_${splited[1]}"]`).click();
            document
                .querySelector(
                    `[data-accordion="${splited[0]}_${splited[1]}_${splited[2]}"]`,
                )
                .click();
        }
    }

    /**
     * HAMMER WEB - LIVE MAP
     */
    const mapWrapper = document.querySelector('.map-wrapper');
    if (mapWrapper) {
        /*const platform = new H.service.Platform({
            apikey: window.here.api_key,
        });
        const layers = platform.createDefaultLayers();
        const map = new H.Map(mapWrapper, layers.raster.normal.map, {
            center: {
                lat: 39.357835,
                lng: -97.659766,
            },
            zoom: 5,
            pixelRatio: window.devicePixelRatio || 1,
            engineType: H.map.render.RenderEngine.EngineType.P2D,
            padding: {
                top: false ? 300 : 200,
                left: false ? 100 : 400,
                bottom: 100,
                right: 100,
            },
        });
        const behavior = new H.mapevents.Behavior(
            new H.mapevents.MapEvents(map),
        );

        behavior.disable(H.mapevents.Behavior.Feature.PANNING);
        behavior.disable(
            H.mapevents.Behavior.Feature.DBL_TAP_ZOOM,
        );
        behavior.disable(
            H.mapevents.Behavior.Feature.FRACTIONAL_ZOOM,
        );
        behavior.disable(H.mapevents.Behavior.Feature.HEADING);
        behavior.disable(H.mapevents.Behavior.Feature.TILT);
        behavior.disable(H.mapevents.Behavior.Feature.WHEEL_ZOOM);

        behavior.enable(H.mapevents.Behavior.Feature.PINCH_ZOOM);
        // behavior.enable(H.mapevents.Behavior.Feature.WHEEL_ZOOM);
        behavior.enable(H.mapevents.Behavior.DRAGGING);*/
        document
            .querySelector('.route-planning__widget')
            .addEventListener('click', () => {
                gtag('event', 'WIDGET_CLICKED', {
                    event_category: 'WIDGET',
                });
                window.location = window.liveUrl;
            });

        const mapImage = document.querySelector('.route-planning-map');
        if (mapImage) {
            mapImage.addEventListener('click', () => {
                gtag('event', 'WIDGET_CLICKED', {
                    event_category: 'WIDGET',
                });
                window.location = window.liveUrl;
            });
        }
        /*window.addEventListener('resize', () => {
            map.getViewPort().resize();
        });*/

        /*const overlay = document.querySelector(
            '#map-overlay',
        );

        let timeout;
        let zoomingTimeout;
        let zooming = false;*/
        /* eslint-disable-next-line */
        /*function canvasWheelEvent(event) {
            if (event.ctrlKey || event.metaKey) {
                event.preventDefault();
                const canvas = document.querySelector(
                    'canvas',
                );
                const rect = canvas.getBoundingClientRect();
                const x = event.clientX;
                const y = event.clientY;
                const coord = map.screenToGeo(
                    x - rect.left,
                    y - rect.top,
                );
                const target = new H.map.Circle(
                    new H.geo.Point(coord.lat, coord.lng),
                    1000000,
                );
                const delta = event.wheelDelta ? event.wheelDelta : (event.deltaY * -1);
                if (delta < 0 && !zooming) {
                    zooming = true;
                    map.getViewModel().setLookAtData(
                        {
                            zoom: map.getZoom() - 1,
                            bounds: target.getBoundingBox(),
                        },
                        true,
                    );
                    clearTimeout(zoomingTimeout);
                    zoomingTimeout = setTimeout(() => {
                        zooming = false;
                    }, 400);
                } else if (delta > 0 && !zooming) {
                    zooming = true;
                    map.getViewModel().setLookAtData(
                        {
                            zoom: map.getZoom() + 1,
                            bounds: target.getBoundingBox(),
                        },
                        true,
                    );
                    clearTimeout(zoomingTimeout);
                    zoomingTimeout = setTimeout(() => {
                        zooming = false;
                    }, 400);
                }
            } else {
                overlay.classList.remove('hidden');
                overlay.classList.add('flex');
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    overlay.classList.remove('flex');
                    overlay.classList.add('hidden');
                }, 1000);
            }
        }
        document.querySelector('canvas').addEventListener('wheel', canvasWheelEvent);

        document.querySelector('#map-overlay').addEventListener('wheel', (event) => {
            if (event.ctrlKey || event.metaKey) {
                event.preventDefault();
                overlay.classList.remove('flex');
                overlay.classList.add('hidden');
            } else {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    overlay.classList.remove('flex');
                    overlay.classList.add('hidden');
                }, 1000);
            }
        });

        // Win vs Mac
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0) {
            document.querySelector('#map-overlay .win').classList.add('hidden');
        } else {
            document.querySelector('#map-overlay .mac').classList.add('hidden');
        }
        */
    }

    /**
     * Google Analytics
     * Apps download buttons
     */
    document.querySelectorAll('.ios-button').forEach((element) => {
        element.addEventListener('click', () => {
            gtag('event', 'DOWNLOAD_BANNER_IOS', {
                event_category: 'BANNER',
            });
        });
    });

    document.querySelectorAll('.android-button').forEach((element) => {
        element.addEventListener('click', () => {
            gtag('event', 'DOWNLOAD_BANNER_ANDROID', {
                event_category: 'BANNER',
            });
        });
    });
});

// if (document.querySelector('#admin-app')) {
    // Components




/* eslint-disable */
const files = require.context('./', true, /\.vue$/i);
files
    .keys()
    .map((key) =>
        Vue.component(key.split('/').pop().split('.')[0], files(key).default),
    );
/* eslint-enable */



// TODO: remove??
    // Vue.component(
    //     'page-integrate-us',
    //     require.context('./components/PageIntegrateUs').default,
    // );
    // Vue.component(
    //     'page-support',
    //     require.context('./components/PageSupport').default,
    // );
    // Vue.component(
    //     'modal',
    //     require.context('./components/Modal').default,
    // );

    // Vue.use(VueRouter);
    // Vue.component('MarkdownEditor', MarkdownEditor);

    // const router = new VueRouter({
    //     mode: 'history',
    //     routes: [
    //         {
    //             path: '/admin',
    //             component: require.context('./layouts/Admin').default,
    //             children: [
    //                 {
    //                     name: 'home',
    //                     path: '',
    //                     component: require.context('./views/Pages')
    //                         .default,
    //                 },
    //             ],
    //         },
    //     ],
    // });
    // const app = new Vue({
    //     el: '#admin-app',
    //     router,
    // });

    // window.app = app;
// }


/**
 * Router
 */
Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/app/',
            alias: '/live/',
            component: require.context('./layouts/Map').default,
            children: [
                {
                    name: 'home',
                    path: '',
                    component: require.context('./views/Welcome').default,
                },
                {
                    name: 'route',
                    path: 'calculated-route/:guid',
                    component: require.context('./views/Welcome').default,
                },
                {
                    name: 'detail',
                    path: 'detail/:poiguid',
                    component: require.context('./views/Welcome').default,
                },
                {
                    name: 'profile',
                    path: 'profile',
                    component: require.context('./views/Profile').default,
                },
                {
                    name: 'preferences',
                    path: 'preferences',
                    component: require.context('./views/Preferences').default,
                },
                {
                    name: 'preferences-for-user',
                    path: 'preferences/:guid',
                    component: require.context('./views/Preferences').default,
                },
                {
                    name: 'cookies',
                    path: 'cookies',
                    component: require.context('./views/Cookies').default,
                },
                {
                    name: 'licenses',
                    path: 'licenses',
                    component: require.context('./views/Licenses').default,
                },
                {
                    name: 'eula',
                    path: 'eula',
                    component: require.context('./views/Eula').default,
                },
                {
                    name: 'feedback',
                    path: 'feedback',
                    component: require.context('./views/Feedback').default,
                },
                {
                    name: 'about',
                    path: 'about',
                    component: require.context('./views/About').default,
                },
                {
                    name: 'deep-link-search',
                    path: 'search/:location',
                    component: require.context('./views/Welcome').default,
                },
                {
                    name: 'deep-link-route',
                    path: 'route/*',
                    component: require.context('./views/Welcome').default,
                },
            ],
        },
        {
            name: 'page-not-found',
            path: '*',
            component: require.context('./layouts/PageNotFound').default,
        },
    ],
});

/**
 * Global Vue mixin
 */
Vue.mixin({
    data() {
        return {
            isMobile:
                document.querySelector('.hidden-mobile').offsetParent == null,
        };
    },
    methods: {
        checkIfMobile() {
            const mobileChecker = document.querySelector('.hidden-mobile');
            this.isMobile = mobileChecker.offsetParent == null;
        },
        assetUrl(path) {
            return `/${path}`;
        },
    },
    created() {
        window.addEventListener('resize', this.checkIfMobile);
    },
    destroyed() {
        window.removeEventListener('resize', this.checkIfMobile);
    },
});

if(window.config) {
    Vue.use(VueGtag, {
        config: {
            id: window.config.ga_id,
        },
    });
}

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.mixin({
    methods: {
        url(text) {
            return url(text);
        }
    }
});

if(document.getElementById("app-live")) {
    const app = new Vue({
        el: '#app-live',
        router,
        data() {
            return {
                downloadBanner: true,
            };
        },
        mounted() {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        },
    });

    window.app = app;
}
